// Import all actions
import * as actions from "../actions/summerPointsActions";
import {
  calculateTableData,
  calculateTableDataForHeating,
  calculateTableDataForCooling,
  calculateTableDataForMixing,
  calculateTableDataForSteamHumidify,
} from "../utils/calculationFunctions";

export const initialState = {
  summerPoints: [
    {
      id: 0,
      temperatureDryBulb: 35,
      temperatureWetBulb: 23.8,
      temperatureDewPoint: 0,
      relativeHumidity: 40,
      absoluteHumidity: 14.3,
      enthalpy: 72.1,
      airFlowHours: 10000,
      airFlowSeconds: 0,
      massFlow: 1.55,
      realFlow: 0,
      airDensity: 1.12,
      usedPower: 0,
      usedWater: 0,
      process: "outdoor",
      calcParameter: "",
    },
    {
      id: 1,
      temperatureDryBulb: 22,
      temperatureWetBulb: 13.8,
      temperatureDewPoint: 0,
      relativeHumidity: 40,
      absoluteHumidity: 6.7,
      enthalpy: 39.1,
      airFlowHours: 0,
      airFlowSeconds: 0,
      massFlow: 0,
      realFlow: 0,
      airDensity: 0,
      usedPower: 0,
      usedWater: 0,
      process: "indoor",
      calcParameter: "",
    },
  ],
  /* winterPoints: [
    {
      temperatureDryBulb: 0,
      temperatureWetBulb: 0,
      temperatureDewPoint: 0,
      relativeHumidity: 0,
      absoluteHumidity: 0,
      enthalpy: 0,
      airFlowHours: 0,
      airFlowSeconds: 0,
      massFlow: 0,
      realFlow: 0,
      airDensity: 0,
      usedPower: 0,
      usedWater: 0,
      process: "outdoor",
    },
    {
      temperatureDryBulb: 0,
      temperatureWetBulb: 0,
      temperatureDewPoint: 0,
      relativeHumidity: 0,
      absoluteHumidity: 0,
      enthalpy: 0,
      airFlowHours: 0,
      airFlowSeconds: 0,
      massFlow: 0,
      realFlow: 0,
      airDensity: 0,
      usedPower: 0,
      usedWater: 0,
      process: "indoor",
    },
  ],*/
};

export default function summerPointsReducer(state = initialState, action) {
  const {
    temperatureDryBulb,
    temperatureWetBulb,
    temperatureDewPoint,
    relativeHumidity,
    absoluteHumidity,
    enthalpy,
    airFlowHours,
    airFlowSeconds,
    massFlow,
    realFlow,
    airDensity,
    usedPower,
    usedWater,
    process,
  } = action;
  console.log(action);
  const arrayLength = state.summerPoints.length;

  const outdoorPoint = state.summerPoints[0];
  //const pointForCalculation = state.summerPoints[arrayLength - 2];
  const updatedArray = [...state.summerPoints];
  console.log(action.type);
  switch (action.type) {
    /*   case actions.ADD_PROCESSPOINT:
      return [
        ...state,
        {
          temperatureDryBulb,
          temperatureWetBulb,
          temperatureDewPoint,
          relativeHumidity,
          absoluteHumidity,
          enthalpy,
          airFlowHours,
          airFlowSeconds,
          massFlow,
          realFlow,
          airDensity,
          usedPower,
          usedWater,
          process,
        },
      ];*/
    case actions.SET_INITIAL_STATE:
      return { ...state, summerPoints: initialState.summerPoints };
    /*  case actions.UPDATE_PROCESSPOINT:
      return [
        ...state,
        {
          temperatureDryBulb,
          temperatureWetBulb,
          temperatureDewPoint,
          relativeHumidity,
          absoluteHumidity,
          enthalpy,
          airFlowHours,
          airFlowSeconds,
          massFlow,
          realFlow,
          airDensity,
          usedPower,
          usedWater,
          process,
        },
      ];*/
    case actions.UPDATE_AIRFLOW:
      let outdoorAirFlow = Math.round(
        +action.payload.airFlow * (+action.payload.mixingRatio / 100)
      );
      let indoorAirFlow = Math.round(
        +action.payload.airFlow * ((100 - +action.payload.mixingRatio) / 100)
      );

      let outdoorForChange = updatedArray[0];
      outdoorForChange.airFlowHours =
        action.payload.airFlowUnit === 10
          ? outdoorAirFlow
          : outdoorAirFlow * 3600;
      outdoorForChange.airFlowSeconds =
        action.payload.airFlowUnit === 10
          ? outdoorAirFlow / 3600
          : outdoorAirFlow;
      let indoorForChange = updatedArray[1];
      indoorForChange.airFlowHours =
        action.payload.airFlowUnit === 10
          ? indoorAirFlow
          : indoorAirFlow * 3600;
      indoorForChange.airFlowSeconds =
        action.payload.airFlowUnit === 10
          ? indoorAirFlow / 3600
          : indoorAirFlow;
      updatedArray[0] = outdoorForChange;
      updatedArray[1] = indoorForChange;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.UPDATE_INDOORPOINT:
      // const indoorArray = [...state.summerPoints]; // Create a shallow copy of the array
      updatedArray[1] = action.payload; // Update the first element
      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.UPDATE_OUTDOORPOINT:
      //const outdoorArray = [...state.summerPoints]; // Create a shallow copy of the array
      updatedArray[0] = action.payload; // Update the first element
      return {
        ...state,
        summerPoints: updatedArray,
      };
    /* case actions.GET_ARRAY_DATA:
      return {
        ...state,
      };*/
    case actions.ADD_NEW_SUMMER_PROCESSPOINT:
      const newSummerPoint = {
        id: arrayLength,
        temperatureDryBulb: 0,
        temperatureWetBulb: 0,
        temperatureDewPoint: 0,
        relativeHumidity: 0,
        absoluteHumidity: 0,
        enthalpy: 0,
        airFlowHours: 0,
        airFlowSeconds: 0,
        massFlow: 0,
        realFlow: 0,
        airDensity: 0,
        usedPower: 0,
        usedWater: 0,
        process: "",
        calcParameter: "",
      };
      return {
        ...state,
        summerPoints: [...state.summerPoints, newSummerPoint],
      };
    case actions.CHANGE_POINT_PROCESS:
      const passedPoint = state.summerPoints.find(
        (item) => item.id === action.payload.processID
      );

      passedPoint.process = action.payload.processName;

      updatedArray[passedPoint.id] = passedPoint;

      return {
        ...state,
        summerPoints: updatedArray,
      };
    case actions.DELETE_PROCESS_POINT:
      let newArray = [];

      newArray = updatedArray
        .filter((item) => item.id !== action.payload)
        .map((item, index) => ({
          ...item,
          id: index,
        }));

      return {
        ...state,
        summerPoints: newArray,
      };

    case actions.ADD_OR_UPDATE_HEATINGPOINT:
      const passedHeatingPoint = state.summerPoints.find(
        (item) => item.id === action.payload.processID
      );
      const pointForCalculationHeating =
        state.summerPoints[action.payload.processID - 1];
      //Kalkulacija parametara za novu tačku
      const {
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedHeating,
        absoluteHumidity: absoluteHumidityHeating,
        relativeHumidity: relativeHumidityHeating,
        enthalpy: enthalpyHeating,
        massFlow: massFlowHeating,
        realFlow: realFlowheating,
        airDensity: airDensityHeating,
        usedPower: usedPowerHeating,
        usedWater: usedWaterHeating,
      } = calculateTableDataForHeating(
        action.payload.heatingTemperature,
        action.payload.elevation,
        passedHeatingPoint.id === 2 ? outdoorPoint : pointForCalculationHeating
      );

      //Kopija niza koja će biti izmenjena

      const newHeatingPoint = {
        id: passedHeatingPoint.id,
        temperatureDryBulb: +action.payload.heatingTemperature,
        temperatureWetBulb: temperatureWetBulbCalculatedHeating,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumidityHeating,
        absoluteHumidity:
          passedHeatingPoint.id === 2
            ? outdoorPoint.absoluteHumidity
            : pointForCalculationHeating.absoluteHumidity,
        enthalpy: enthalpyHeating,
        airFlowHours:
          passedHeatingPoint.id === 2
            ? outdoorPoint.airFlowHours
            : pointForCalculationHeating.airFlowHours,
        airFlowSeconds:
          passedHeatingPoint.id === 2
            ? outdoorPoint.airFlowHours / 3600
            : pointForCalculationHeating.airFlowHours / 3600,
        massFlow: massFlowHeating,
        realFlow: realFlowheating,
        airDensity: airDensityHeating,
        usedPower: usedPowerHeating,
        usedWater: usedWaterHeating,
        process: 10,
      };

      updatedArray[passedHeatingPoint.id] = newHeatingPoint;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.ADD_OR_UPDATE_COOLINGPOINT:
      const passedCoolingPoint = state.summerPoints.find(
        (item) => item.id === action.payload.processID
      );

      const pointForCalculationCooling =
        state.summerPoints[action.payload.processID - 1];

      const {
        temperatureDryBulbCalculated: temperatureDryBulbCalculatedCooling,
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedCooling,
        absoluteHumidity: absoluteHumidityCooling,
        relativeHumidity: relativeHumidityCooling,
        enthalpy: enthalpyCooling,
        massFlow: massFlowCooling,
        realFlow: realFlowCooling,
        airDensity: airDensityCooling,
        usedPower: usedPowerCooling,
        usedWater: usedWaterCooling,
      } = calculateTableDataForCooling(
        action.payload.coolingTemperature,
        action.payload.P,
        action.payload.airFlowHours,
        action.payload.airFlowSeconds,
        action.payload.coolerTemperature,
        action.payload.elevation,
        action.payload.maxHumidityInProcess,
        passedCoolingPoint.id === 2 ? outdoorPoint : pointForCalculationCooling
      );

      const newCoolingPoint = {
        id: passedCoolingPoint.id,

        temperatureDryBulb:
          action.payload.P !== null
            ? temperatureDryBulbCalculatedCooling
            : +action.payload.coolingTemperature,
        temperatureWetBulb: temperatureWetBulbCalculatedCooling,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumidityCooling,
        absoluteHumidity: absoluteHumidityCooling,
        enthalpy: enthalpyCooling,
        airFlowHours: pointForCalculationCooling.airFlowHours,
        airFlowSeconds: pointForCalculationCooling.airFlowHours / 3600,
        massFlow: massFlowCooling,
        realFlow: realFlowCooling,
        airDensity: airDensityCooling,
        usedPower: usedPowerCooling,
        usedWater: usedWaterCooling,
        process: 20,
        calcParameter: action.payload.P !== null ? 20 : 10,
      };
      updatedArray[passedCoolingPoint.id] = newCoolingPoint;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.ADD_OR_UPDATE_MIXINGPOINT:
      const passedMixingPoint = state.summerPoints.find(
        (item) => item.id === action.payload.processID
      );

      const lastPoint = state.summerPoints[action.payload.processID - 1];
      const prevLastPoint = state.summerPoints[action.payload.processID - 2];

      const {
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedMix,
        temperatureDryBulb: temperatureDryBulbMix,
        absoluteHumidity: absoluteHumidityMix,
        relativeHumidity: relativeHumidityMix,
        enthalpy: enthalpyMix,
        massFlow: massFlowMix,
        realFlow: realFlowMix,
        normalFlow: normalFlowMix,
        airDensity: airDensityMix,
        usedPower: usedPowerMix,
        usedWater: usedWaterMix,
      } = calculateTableDataForMixing(
        lastPoint,
        prevLastPoint,
        action.payload.elevation
      );

      const newMixingPoint = {
        id: passedMixingPoint.id,
        temperatureDryBulb: temperatureDryBulbMix,
        temperatureWetBulb: temperatureWetBulbCalculatedMix,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumidityMix,
        absoluteHumidity: absoluteHumidityMix,
        enthalpy: enthalpyMix,
        airFlowHours: normalFlowMix,
        airFlowSeconds: normalFlowMix / 3600,
        massFlow: massFlowMix,
        realFlow: realFlowMix,
        airDensity: airDensityMix,
        usedPower: usedPowerMix,
        usedWater: usedWaterMix,
        process: 30,
      };

      updatedArray[passedMixingPoint.id] = newMixingPoint;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.ADD_OR_UPDATE_STEAMHUMIDITYPOINT:
      const passedSteamPoint = state.summerPoints.find(
        (item) => item.id === action.payload.processID
      );

      const pointForCalculationSteam =
        state.summerPoints[action.payload.processID - 1];

      const {
        temperatureDryBulb: temperatureDryBulbSteam,
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedSteam,
        relativeHumidity: relativeHumiditySteam,
        absoluteHumidity: absoluteHumiditySteam,
        enthalpy: enthalpySteam,
        massFlow: massFlowSteam,
        realFlow: realFlowSteam,
        normalFlow: normalFlowSteam,
        airDensity: airDensitySteam,
        usedPower: usedPowerSteam,
        usedWater: usedWaterSteam,
      } = calculateTableDataForSteamHumidify(
        action.payload.relativeHumidity,
        action.payload.elevation,
        passedSteamPoint.id === 2 ? outdoorPoint : pointForCalculationSteam
      );

      const newPointSteam = {
        id: passedSteamPoint.id,
        temperatureDryBulb: temperatureDryBulbSteam,
        temperatureWetBulb: temperatureWetBulbCalculatedSteam,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumiditySteam,
        absoluteHumidity: absoluteHumiditySteam,
        enthalpy: enthalpySteam,
        airFlowHours: normalFlowSteam,
        airFlowSeconds: normalFlowSteam / 3600,
        massFlow: massFlowSteam,
        realFlow: realFlowSteam,
        airDensity: airDensitySteam,
        usedPower: usedPowerSteam,
        usedWater: usedWaterSteam,
        process: 50,
      };
      updatedArray[passedSteamPoint.id] = newPointSteam;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.CHANGE_OUTDOOR_POINT:
      const { fieldName, value } = action.payload;

      let recalculateOutdoorParams;
      if (fieldName === "temperatureDryBulb")
        recalculateOutdoorParams = {
          temperatureDryBulb: +value,
          relativeHumidity: null,
          airFlowHours: null,
        };
      else if (fieldName === "relativeHumidity")
        recalculateOutdoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: +value,
          airFlowHours: null,
        };
      else
        recalculateOutdoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: null,
          airFlowHours: +value,
        };

      const {
        temperatureWetBulbCalculated,
        absoluteHumidity,
        enthalpy,
        massFlow,
        realFlow,
        airDensity,
      } = calculateTableData(
        recalculateOutdoorParams.temperatureDryBulb ||
          outdoorPoint.temperatureDryBulb,
        outdoorPoint.temperatureWetBulb,
        outdoorPoint.temperatureDewPoint,
        recalculateOutdoorParams.relativeHumidity ||
          outdoorPoint.relativeHumidity,
        0,
        recalculateOutdoorParams.airFlowHours || outdoorPoint.airFlowHours
      );

      const newOutdoorPoint = {
        ...outdoorPoint,
        [fieldName]: +value,
        temperatureWetBulb: temperatureWetBulbCalculated,
        absoluteHumidity: absoluteHumidity,
        enthalpy: enthalpy,
        massFlow: massFlow,
        realFlow: realFlow,
        airDensity: airDensity,
      };
      updatedArray[0] = newOutdoorPoint;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.CHANGE_INDOOR_POINT:
      const { fieldName1, value1 } = action.payload;

      const indoorPoint = state.summerPoints[1];

      let recalculateIndoorParams;
      if (fieldName1 === "temperatureDryBulb")
        recalculateIndoorParams = {
          temperatureDryBulb: +value1,
          relativeHumidity: null,
          airFlowHours: null,
        };
      else if (fieldName1 === "relativeHumidity")
        recalculateIndoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: +value1,
          airFlowHours: null,
        };
      else
        recalculateIndoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: null,
          airFlowHours: +value1,
        };

      const {
        temperatureWetBulbCalculated: temperatureDryBulbCalculatedIndoor,
        absoluteHumidity: absoluteHumidityIndoor,
        enthalpy: enthalpyIndoor,
        massFlow: massFlowIndoor,
        realFlow: realFlowIndoor,
        airDensity: airDensityIndoor,
      } = calculateTableData(
        recalculateIndoorParams.temperatureDryBulb ||
          indoorPoint.temperatureDryBulb,
        indoorPoint.temperatureWetBulb,
        indoorPoint.temperatureDewPoint,
        recalculateIndoorParams.relativeHumidity ||
          indoorPoint.relativeHumidity,
        0,
        recalculateIndoorParams.airFlowHours || indoorPoint.airFlowHours
      );

      const newIndoorPoint = {
        ...indoorPoint,
        [fieldName1]: +value1,
        temperatureWetBulb: temperatureDryBulbCalculatedIndoor,
        absoluteHumidity: absoluteHumidityIndoor,
        enthalpy: enthalpyIndoor,
        massFlow: massFlowIndoor,
        realFlow: realFlowIndoor,
        airDensity: airDensityIndoor,
      };
      updatedArray[1] = newIndoorPoint;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.ADD_DLL_EHA_POINT:
      updatedArray[updatedArray.length] = action.payload;

      return {
        ...state,
        summerPoints: updatedArray,
      };

    case actions.ADD_DLL_SUP_POINT:
      const newArrayDll = [
        ...updatedArray.slice(0, 1),
        action.payload,
        ...updatedArray.slice(1),
      ];

      return {
        ...state,
        summerPoints: newArrayDll,
      };

    case actions.ADD_COOLER_SUP_POINT:
      const newArrayDll3 = [
        ...updatedArray.slice(0, 2),
        action.payload,
        ...updatedArray.slice(2),
      ];
      return {
        ...state,
        summerPoints: newArrayDll3,
      };
    case actions.ADD_COOLER_EHA_POINT:
      const newArrayDll4 = [
        ...updatedArray.slice(0, 4),
        action.payload,
        ...updatedArray.slice(4),
      ];
      return {
        ...state,
        summerPoints: newArrayDll4,
      };
    default:
      return state;
  }
}
